import React from 'react'

const Inspector = ({ children }: React.PropsWithChildren<unknown>) => <>{children}</>

export default Inspector
